export default __webpack_public_path__ + "static/media/Discover.89629a06.svg";